
<div class="script-editor">
	<div
		ref="editorContainer"
		class="script-editor__container"
		:class="{
			'script-editor__container--disabled': disabled
		}"
	/>
</div>
